import { useRouter } from "next/router";
import { useEffect } from "react";
const PassWebsiteTracking = () => {
  const router = useRouter();
  const query = router.query;

  function getCampaign(queryValue: string | string[] | undefined) {
    if (Array.isArray(queryValue)) return queryValue[0];
    return queryValue ?? null;
  }

  useEffect(() => {
    const crmCampaign =
      getCampaign(query?.utm_campaign) ||
      sessionStorage.getItem("crm_campaign");
    if (!crmCampaign) return;

    const allowedDomains = ["gmat.london.edu", "gre.london.edu"];

    const handleClick = (e: MouseEvent) => {
      const target = (e.target as HTMLElement)?.closest("a");
      if (!target) return; // Not a link

      try {
        const url = new URL(target.href);
        if (!allowedDomains.includes(url.hostname)) return;
        url.searchParams.set("utm_campaign", crmCampaign);
        e.preventDefault();
        window.location.href = url.toString();
      } catch {
        // Ignore invalid URLs
      }
    };
    document.addEventListener("click", handleClick);
    // Cleanup when component unmounts
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [router.isReady, router.query?.utm_campaign]);
};
export default PassWebsiteTracking;
